var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import EJSON from 'ejson';
/**
 * Generic resource class represents any ShareFile resource.
 */
export class Resource {
    constructor(rid, props = {}) {
        this._hydrated = false;
        this._propertyKeys = [];
        this._rid = rid;
        if (Object.keys(props).length) {
            this._setMembers(props);
            this._hydrated = true;
        }
    }
    _setMembers(members) {
        for (let key in members) {
            if (typeof key === "symbol") {
                continue;
            }
            if (!(members[key] instanceof Function)) {
                this._propertyKeys.push(key);
            }
            this[key] = members[key];
        }
    }
    _getProps() {
        return this._propertyKeys.reduce((a, [_v, k]) => {
            a[k] = this[k];
            return a;
        }, {});
    }
    getRid() {
        return this._rid;
    }
    /**
     * If not hydrated, will call resolver to get properties from plugin.
     * @param resolver
     * @returns Resource
     */
    hydrate(resolver) {
        return __awaiter(this, void 0, void 0, function* () {
            this._resolver = resolver;
            if (!this._hydrated) {
                this._setMembers(yield this._resolver.resolveProperties());
                this._hydrated = true;
            }
            return this;
        });
    }
    /**
     * EJSON required method to serialize the object
     * @returns object
     */
    toJSONValue() {
        return {
            rid: this._rid,
            props: EJSON.toJSONValue(this._getProps()),
        };
    }
    /**
     * EJSON required method to return type name
     * @returns string
     */
    typeName() {
        return 'Resource';
    }
}
//# sourceMappingURL=resource.js.map